import { CrudManagerConfig } from '@bryntum/scheduler';
import { BryntumScheduler, BryntumSchedulerProps } from '@bryntum/scheduler-react';
import { FC, MutableRefObject, useEffect } from 'react';
import { toSchedulerEvents, useEasternCurrentTimeLine } from '../../DispatchesHelper';
import { useColumnManager } from '../Grids/useColumnManager';

interface Props {
    schedulerRef: MutableRefObject<BryntumScheduler>;
    config: BryntumSchedulerProps;
    resources?: any[];
    events?: any[];
    crudManager: CrudManagerConfig;
    onEventStoreUpdate: ({ record, changes }: { record: any; changes: any }) => void;
}
export const OrderDispatchingViewScheduler: FC<Props> = (props) => {
    const { schedulerRef, config, resources, events, crudManager, onEventStoreUpdate } = props;
    const { orderViewSchedulerDefaultColumnConfigs } = useColumnManager();

    useEasternCurrentTimeLine(schedulerRef?.current?.instance);

    useEffect(() => {
        if (!schedulerRef?.current?.instance?.eventStore) {
            return;
        }
        const eventStore = schedulerRef.current.instance.eventStore;
        Object.assign(eventStore, {
            onUpdate: onEventStoreUpdate,
        });
    }, [onEventStoreUpdate, schedulerRef, schedulerRef?.current?.instance?.eventStore]);

    useEffect(() => {
        if (!schedulerRef?.current?.instance) {
            return;
        }
        const eventStore = schedulerRef?.current?.instance?.eventStore;
        if (events) {
            eventStore.data = toSchedulerEvents(events);
        }

        async function commit() {
            await eventStore.project.commitAsync();
        }

        commit().then(() => {
            schedulerRef?.current?.instance?.refreshRows();
        });
    }, [events, schedulerRef, schedulerRef?.current?.instance]);

    useEffect(() => {
        if (!schedulerRef?.current?.instance) {
            return;
        }
        const resourceStore = schedulerRef.current.instance.resourceStore;
        if (resources) {
            resourceStore.data = resources;
        }

        async function commit() {
            await resourceStore.project.commitAsync();
        }

        commit().then(() => {
            schedulerRef?.current?.instance?.refreshRows();
        });
    }, [resources, schedulerRef, schedulerRef?.current?.instance]);

    return (
        <>
            <BryntumScheduler
                ref={schedulerRef}
                eventDragFeature={{ showTooltip: true }}
                columns={orderViewSchedulerDefaultColumnConfigs}
                crudManager={crudManager}
                {...config}
            />
        </>
    );
};
